import { useSelector } from 'react-redux';

export const useGeneral = () => {
    //@ts-ignore
    const { modalMode } = useSelector((state) => state.dashboardReducer);

    return { modalMode };
};
